import { environment } from "@/aws-exports";
import axios from "axios";

const ENDPOOINT = environment.API.endpoints[1].endpoint;

function getNotifications() {
  return new Promise( async (resolve, reject) => {
    try {
      const response = await axios.get(`${ENDPOOINT}/notifications.json`);
      console.log(response);
      if (response.status === 200) {
        resolve(response.data);
      } else {
        reject(response);
      }
    } catch (err) {
      reject(err);
    }
  });
}

const services = {
  getNotifications,
};

export default services;
